export default function FeaturedGame() {
  return (
    <section id="choke-point" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            <div className="inline-block bg-orange-100 text-orange-700 px-4 py-1.5 rounded-full text-sm font-semibold mb-6">
              COMING SOON
            </div>
            <h3 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              CHOKE POINT
            </h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              <strong>Choke Point</strong> is a tactical strategy board game where players compete to control critical map positions. Command your forces, manage resources, and execute brilliant maneuvers to dominate the battlefield. Every decision matters in this intense game of strategic warfare.
            </p>
            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-user-line text-xl text-orange-600"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">2-4 Players</p>
                  <p className="text-sm text-gray-600">Perfect for game nights with friends</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-time-line text-xl text-orange-600"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">30-60 Minutes</p>
                  <p className="text-sm text-gray-600">Deep strategy in a reasonable timeframe</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-star-line text-xl text-orange-600"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Age 14+</p>
                  <p className="text-sm text-gray-600">Complex tactical gameplay for experienced gamers</p>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-4">
              <button className="bg-orange-600 text-white px-8 py-3 rounded-md text-base font-bold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer">
                Get Your Copy
              </button>
              <button className="border-2 border-gray-900 text-gray-900 px-8 py-3 rounded-md text-base font-bold hover:bg-gray-900 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                View Rules
              </button>
            </div>
          </div>

          <div className="order-1 md:order-2">
            <div className="relative">
              <div className="aspect-square w-full rounded-lg overflow-hidden bg-gray-100 border-2 border-dashed border-gray-300 flex flex-col items-center justify-center">
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className="ri-image-line text-5xl text-gray-400"></i>
                </div>
                <p className="text-gray-500 font-semibold text-lg text-center leading-snug px-6">Currently in development.</p>
                <p className="text-gray-400 text-base text-center mt-1">Art coming soon.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
